import { render } from "./SettingsDialog.vue?vue&type=template&id=e080f3ac&scoped=true&ts=true"
import script from "./SettingsDialog.vue?vue&type=script&lang=ts"
export * from "./SettingsDialog.vue?vue&type=script&lang=ts"

import "./SettingsDialog.vue?vue&type=style&index=0&id=e080f3ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e080f3ac"]])

export default __exports__